import { render, staticRenderFns } from "./LogoStoneRebrand.vue?vue&type=template&id=5afb1dfc&scoped=true&"
import script from "./LogoStoneRebrand.vue?vue&type=script&lang=js&"
export * from "./LogoStoneRebrand.vue?vue&type=script&lang=js&"
import style0 from "./LogoStoneRebrand.vue?vue&type=style&index=0&id=5afb1dfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afb1dfc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/vstsagent03/user/3333/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5afb1dfc')) {
      api.createRecord('5afb1dfc', component.options)
    } else {
      api.reload('5afb1dfc', component.options)
    }
    module.hot.accept("./LogoStoneRebrand.vue?vue&type=template&id=5afb1dfc&scoped=true&", function () {
      api.rerender('5afb1dfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emerald/atoms/LogoStoneRebrand.vue"
export default component.exports